import { Form } from '@unform/web';
import React, { useRef, useState } from 'react';
import { useLanguage } from '../../../../../../hooks/Language';
import CreditCardForm from './modules/CreditCard';
import GeneralForm from './modules/GeneralForm';
import CurrencyInput from '../../../../../../components/Forms/MaskedCurrencyInput';
import CompleteSaleFields from '../../../CompleteSaleFields';
import { FiArrowRight } from 'react-icons/fi';
import calculateDiscount from '../../Functions/calculateDiscount';
import Input from '../../../../../DashboardPages/core/components/Forms/Input';
import MaskedInput from '../../../../../DashboardPages/core/components/Forms/MaskedInput';
import SelectSimple from '../../../../../../components/Forms/SelectSimple';
import { countries } from '../../../Login/countries';
import ReCAPTCHA from 'react-google-recaptcha';
import { recaptchaKey } from '../../../../../../config';
import getCep from '../../../../../../services/cep';
import { FormHandles } from '@unform/core';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import * as Yup from 'yup';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import { useToast } from '../../../../../../hooks/Toast';
import DefaultSignUpFormV4, { checkDocumentNumber } from '../../../../../DefaultSignUpFormV4';
import { useModal } from 'src/hooks/Modal';
interface IProps {
    paymentMethod: 'credit_card' | 'boleto' | 'pix' | 'cortesy' | 'gratuito';

    cart: Array<Record<string, any>>;
    couponInfo?: Record<string, any>;
    changeInstallment: Function;
    installmentValue: number;
    quantity: number;
    sendPaymentRequest: Function;
    applyCoupon: Function;
    courtesyCode: string;
}

const PaymentMethodForm: React.FC<IProps> = ({ courtesyCode, paymentMethod, couponInfo, cart, changeInstallment, installmentValue, quantity, sendPaymentRequest, applyCoupon }) => {

    const { translate } = useLanguage();
    const product = cart?.[0] || {};
    const recaptchaRef = useRef(null);
    const [type, setType] = useState('cpf');
    const [countryISO, setCountryISO] = useState('BR');
    const [company, setCompany] = useState('');
    const formRef = useRef<FormHandles>(null);
    const { addLoading, removeLoading } = useLoading();
    const { addToast } = useToast();
    const { addModal } = useModal();
    const paymentMethodElements = {

        boleto: () => <GeneralForm />,
        pix: () => <GeneralForm />,
        cortesy: () => <></>,
        courtesy: () => <></>,
        gratuito: () => <></>,
    }

    const getCaptchaValue = (elem: any): string => {
        return elem?.getValue ? elem?.getValue() : '';
    };


    const getCepFromApi = async (value: string): Promise<void> => {
        const cepResponse = await getCep(value);

        if (!cepResponse.error) {
            formRef?.current?.setFieldValue('address', cepResponse.logradouro);
            formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
            formRef?.current?.setFieldValue('city', cepResponse.localidade);
            formRef?.current?.setFieldValue('state', cepResponse.uf);
        }
    };



    const validate = async (data) => {
        addLoading({ title: 'validando', key: 'validando' });
        try {
            formRef.current?.setErrors({});


            const shape = data?.category_id === 'Médicos' || data?.category_id === 'Residentes' ? {
                name: Yup.string().required(`${translate('Nome')} ${translate('obrigatório')}`),
                email: Yup.string().email().required(`${translate('E-mail')} ${translate('obrigatório')}`),
                phone: Yup.string().required(`${translate('Telefone')} ${translate('obrigatório')}`),
                document_number: Yup.string().required(`${translate('CPF')} ${translate('obrigatório')}`),
                category_id: Yup.string().required(`${translate('Categoria')} ${translate('obrigatório')}`),
                company: Yup.string().required(`${translate('Instituição/Empresa')} ${translate('obrigatório')}`),
                know_about: Yup.string().required(`${translate('Informe como soube do evento')}`),
            } : {
                name: Yup.string().required(`${translate('Nome')} ${translate('obrigatório')}`),
                email: Yup.string().email().required(`${translate('E-mail')} ${translate('obrigatório')}`),
                phone: Yup.string().required(`${translate('Telefone')} ${translate('obrigatório')}`),
                document_number: Yup.string().required(`${translate('CPF')} ${translate('obrigatório')}`),
                company: Yup.string().required(`${translate('Instituição/Empresa')} ${translate('obrigatório')}`),
                know_about: Yup.string().required(`${translate('Informe como soube do evento')}`),
            }

            const schema = Yup.object().shape(shape);


            data.document_number = data?.document_number?.toString().replace(/[^0-9]/g, '') || '';
            if (data.company_document_number) {
                data.company_document_number = data?.company_document_number?.toString().replace(/[^0-9]/g, '') || '';
            }
            const check = await checkDocumentNumber(data.document_number);

            if (check !== 'yes') {
                await schema.validate(data, { abortEarly: false });

            }


            if (data?.term) {
                data.term = data?.term[0]
            }


            data.inscricao_1 = data?.inscricao_1 ? data.inscricao_1[0] : '';
            data.inscricao_2 = data?.inscricao_2 ? data.inscricao_2[0] : '';


            if (data?.name && !data?.term) {
                addModal({ theme: 'whiteModalMedium', title: '', content: <><h2 style={{ width: '100%', textAlign: 'center', fontSize: '12px', color: '#333' }}>{translate('Confirme a sua concordância com o termo de aceite.')}</h2></> })
                removeLoading('validando');
                return;
            }


            sendPaymentRequest({ check, data, paymentMethod: calculateDiscount(couponInfo, cart).discountedValue > 0 ? paymentMethod : 'boleto', cart, coupon: couponInfo, courtesy: courtesyCode });
            removeLoading('validando');

        }
        catch (err) {
            if (err instanceof Yup.ValidationError) {
                const errors = getValidationErrors(err);

                formRef.current?.setErrors(errors);

                const errorInfo = err.errors.reduce((error, prev) => {
                    prev = `${prev}, ${error}`;
                    return prev;
                });
                removeLoading('validando')
                addToast({
                    type: 'error',
                    title: 'Erro de validação',
                    description: errorInfo,
                });
            }
            console.log(err)
            removeLoading('validando')
        }




    }

    const [checkUser, setCheckUser] = useState('');



    return <>

        <Form className="form" style={{ width: '100%' }}
            ref={formRef}
            initialData={{ country: "BR", installments: installmentValue, quantity: quantity, document_type: type }}
            onSubmit={(data) => { data.recaptcha = getCaptchaValue(recaptchaRef?.current); validate(data) }}

        >



            <div className='outerBlock'>
                <h2 style={{ margin: ' 0px', fontSize: '14px', marginBottom: '5px', width: '100%', color: '#333', borderBottom: '3px solid #0a4f4b', padding: '5px 0px', textAlign: 'left' }}>{translate('3. Dados do Inscrito(a)')}</h2>
                <DefaultSignUpFormV4 key={`product-${cart?.[0]?.hash_link}`} keyName={`product-${cart?.[0]?.hash_link}`} cart={cart} checkUserValue={(value) => setCheckUser(value)} countryISO='BR' changeCountry={(value) => { }} />

            </div>

            <div style={{ marginTop: '10px' }} />


            {checkUser ? <>
                <div className='outerBlock' style={{ display: 'none' }}>

                    <h2 style={{ margin: ' 0px', fontSize: '14px', marginBottom: '5px', width: '100%', color: '#333', borderBottom: '3px solid #c3a257', padding: '5px 0px', textAlign: 'left' }}>{translate('Emitir como Pessoa Física ou PJ?')}</h2>


                    <SelectSimple index={10} style={{ zIndex: 100000 }}
                        setCallback={(value) => setType(value)}
                        options={[
                            { value: 'cpf', label: translate('Pessoa Física') },
                            {
                                value: 'cnpj',
                                label: translate('Entidade / Pessoa Jurídica'),
                            },
                        ]}
                        name="document_type"

                        label={translate('Emitir como')}
                    />

                    {type === 'cnpj' ? <>

                        <Input type='text' name='company' placeholder='Razão social' />
                        <MaskedInput mask='99.999.999/9999-99' type='text' name='company_document_number' placeholder='CNPJ' />



                    </> : <></>}

                </div>

                <p style={{ fontSize: '12px', textAlign: 'center', width: '100%', margin: '10px 0px', color: '#333' }}>Ao me inscreve, afirmo que li e concordo com a política de privacidade e os termos de cancelamento e reembolso desta plataforma.</p>
                <aside style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', alignItems: 'center' }}>
                    <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />

                </aside>



                <button className='greenButton2 buttonColored' type="submit">
                    {translate('Finalizar')}

                </button>

            </> : <> </>}

        </Form>
    </>

};
export default PaymentMethodForm;
